var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDislikeSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f85565;}.cls-2,.cls-3{fill:#393c54;}.cls-2,.cls-7{opacity:0.2;}.cls-4{fill:#fff;}.cls-5{fill:#515570;opacity:0.1;}.cls-6,.cls-7{fill:none;stroke:#393c54;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53,107A71.65,71.65,0,0,1,16.25,96.91,58,58,0,0,0,121.56,57,72,72,0,0,1,53,107Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.3,76.14c1.91.5,3.51-1.74,3.28-3.7C91.77,57.54,79.22,49,64,49S36.23,57.54,34.42,72.44c-.24,2,1.37,4.23,3.28,3.7C47.92,73.26,79.41,73.31,90.3,76.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83,74.92V68.14a4,4,0,0,0-4-4H49a4,4,0,0,0-4,4v6.74A201.51,201.51,0,0,1,83,74.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83,57.14v-2.6A33,33,0,0,0,64,49a33,33,0,0,0-19,5.54v2.6a4,4,0,0,0,4,4H79A4,4,0,0,0,83,57.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,71.88v3a201.51,201.51,0,0,1,38,0v-3A201.51,201.51,0,0,0,45,71.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,53a33.09,33.09,0,0,1,18.78,5.38A4,4,0,0,0,83,57.14v-2.6A33,33,0,0,0,64,49a33,33,0,0,0-19,5.54v2.6a4,4,0,0,0,.22,1.25A33.09,33.09,0,0,1,64,53Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32,36s9-2,14,4c-5-1-12,2-15,6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96,36s-9-2-14,4c5-1,12,2,15,6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 57,
    x2: 71,
    y1: 80,
    y2: 80
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeSmiley);
export default __webpack_public_path__ + "static/media/dislike_smiley.6c7ca35ed28194788ffff05feef08f49.svg";
export { ForwardRef as ReactComponent };